import {
  __export
} from "./chunk-IEP6GGEX.mjs";

// src/SqlTransaction.ts
var SqlTransaction_exports = {};
__export(SqlTransaction_exports, {
  SqlTransaction: () => SqlTransaction,
  clientLayer: () => clientLayer,
  layer: () => layer
});
import * as SqlClient from "@effect/sql/SqlClient";
import * as Context from "effect/Context";
import * as Effect from "effect/Effect";
import * as Layer from "effect/Layer";
var SqlTransaction = class extends Context.Tag("@dxos/sql-sqlite/SqlTransaction")() {
};
var layer = Layer.effect(SqlTransaction, Effect.map(SqlClient.SqlClient, (sql) => ({
  withTransaction: (self) => sql.withTransaction(self)
})));
var clientLayer = Layer.effect(SqlClient.SqlClient, Effect.gen(function* () {
  const sql = yield* SqlClient.SqlClient;
  const transaction = yield* SqlTransaction;
  return new Proxy(sql, {
    get: (target, property, receiver) => property === "withTransaction" ? transaction.withTransaction : Reflect.get(target, property, receiver)
  });
}));

export {
  SqlTransaction,
  layer,
  clientLayer,
  SqlTransaction_exports
};
//# sourceMappingURL=chunk-5JN7ELOA.mjs.map
